import React from "react";
import { ArrowRight, BarChart3 } from "lucide-react";
import "./PremiumHubPage.css";

const PremiumHubPage = ({ title, subtitle, sections = [] }) => (
  <section className="premium-hub-page">
    <div className="premium-hub-head">
      <div>
        <h1>{title}</h1>
        <p>{subtitle}</p>
      </div>
    </div>

    <div className="premium-hub-grid">
      {sections.map((section) => (
        <article className="premium-hub-section" key={section.title}>
          <div className="premium-hub-section-title">
            <span>
              <BarChart3 size={18} />
            </span>
            <h2>{section.title}</h2>
          </div>
          <div className="premium-hub-list">
            {section.items.map((item) => {
              const Icon = item.icon || BarChart3;
              return (
                <button className="premium-hub-item" key={item.label} onClick={item.onClick}>
                  <span className={`premium-hub-icon ${item.tone || "blue"}`}>
                    <Icon size={18} />
                  </span>
                  <span>
                    <strong>{item.label}</strong>
                    <small>{item.description}</small>
                  </span>
                  <ArrowRight size={17} />
                </button>
              );
            })}
          </div>
        </article>
      ))}
    </div>
  </section>
);

export default PremiumHubPage;
